import React from 'react';
import PropTypes from 'prop-types';
import { useTracking } from '@spa/shared/hooks/tracking';

import Accordion from '../Accordion';

import { Wrapper, Title } from './styles';

const FAQ = ({ title, questionsAnswers, learnMoreText, trackOpen }) => {
  const { track, events } = useTracking();

  const onOpen = question => {
    if (trackOpen) {
      trackOpen(question);

      return;
    }

    track(events.faqOpened, { question });
  };

  return (
    <Wrapper>
      <Title>{title}</Title>
      {questionsAnswers.map(({ question, answer, url }) => (
        <Accordion
          key={question}
          title={question}
          description={answer}
          url={url}
          urlText={learnMoreText}
          onOpen={() => onOpen(question)}
        />
      ))}
    </Wrapper>
  );
};

FAQ.propTypes = {
  title: PropTypes.string.isRequired,
  questionsAnswers: PropTypes.array.isRequired,
  learnMoreText: PropTypes.string.isRequired,
  trackOpen: PropTypes.func
};

export default FAQ;
